











import { Component, Prop, Vue } from "@/shared/vuepack";
import moment from "moment";
import _ from "lodash";
import { useDrivewealthAccountPerformanceStore } from "@/shared/store/drivewealthAccountPerformance";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import {
  DrivewealthAccountIdentifierArgs, DrivewealthAccountPerformance,
  DrivewealthAccountPerformanceFrequency,
  DrivewealthAccountPerformanceSelectOption,
  DrivewealthAccountPerformanceTimePeriod,
  DrivewealthAccountSummary
} from "@/shared/types";

@Component
export default class AccountPerformanceForm extends Vue {
  drivewealthAccountPerformanceStore = useDrivewealthAccountPerformanceStore();
  drivewealthStore = useDrivewealthStore();

  @Prop()
  accountId: number;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  moment = moment;
  selectedTimePeriod = DrivewealthAccountPerformanceTimePeriod.YearToDate;
  isSubmitting = false;

  mounted (): void {
    this.selectedTimePeriod = this.drivewealthAccountPerformanceStore.selectedTimePeriod;
  }

  get accountIdentifiers (): DrivewealthAccountIdentifierArgs {
    return {
      username: this.username,
      partnerId: this.partnerId,
      accountId: this.accountId
    };
  }

  get frequencySelectOptions (): DrivewealthAccountPerformanceSelectOption[] {
    const selectOptions = [];
     Object.keys(DrivewealthAccountPerformanceTimePeriod)
        .forEach(k => {
          const timePeriodOption = DrivewealthAccountPerformanceTimePeriod[k];
          const lookup = _.find(this.timePeriodOptions, x => x.value === timePeriodOption);
          selectOptions.push(lookup);
        });

     return selectOptions;
  }

  get timePeriodOptions (): DrivewealthAccountPerformanceSelectOption[] {
    return [
      {
        text: "1 Month",
        value: DrivewealthAccountPerformanceTimePeriod.Months1,
        frequency: DrivewealthAccountPerformanceFrequency.Daily,
        fromDate: moment().subtract(1, "months")
      },
      {
        text: "3 Months",
        value: DrivewealthAccountPerformanceTimePeriod.Months3,
        frequency: DrivewealthAccountPerformanceFrequency.Monthly,
        fromDate: moment().subtract(3, "months")
      },
      {
        text: "6 Months",
        value: DrivewealthAccountPerformanceTimePeriod.Months6,
        frequency: DrivewealthAccountPerformanceFrequency.Monthly,
        fromDate: moment().subtract(6, "months")
      },
      {
        text: "YTD",
        value: DrivewealthAccountPerformanceTimePeriod.YearToDate,
        frequency: DrivewealthAccountPerformanceFrequency.Monthly,
        fromDate: moment().subtract(moment().diff(moment().startOf("year"), "days"), "months")
      },
      {
        text: "3 Years",
        value: DrivewealthAccountPerformanceTimePeriod.Years3,
        frequency: DrivewealthAccountPerformanceFrequency.Yearly,
        fromDate: moment().subtract(3, "years")
      },
      {
        text: "5 Years",
        value: DrivewealthAccountPerformanceTimePeriod.Years5,
        frequency: DrivewealthAccountPerformanceFrequency.Yearly,
        fromDate: moment().subtract(5, "years")
      }
    ];
  }

  getAccountPerformance (timePeriod: DrivewealthAccountPerformanceTimePeriod): void {
    if (this.isSubmitting) {
      return;
    }

    const selectOption = _.find(this.frequencySelectOptions, x => x.value === timePeriod);

    this.isSubmitting = true;

    this.drivewealthAccountPerformanceStore.setFromDate(selectOption.fromDate.format("YYYY-MM-DD"));
    this.drivewealthAccountPerformanceStore.setSelectedTimePeriod(selectOption.value);
    this.drivewealthAccountPerformanceStore.setSelectedFrequency(selectOption.frequency);
    this.drivewealthAccountPerformanceStore.getAccountPerformance(this.accountIdentifiers)
        .then(x => this.isSubmitting = false);
  }
}
